const CONSENTS_KEY = "client_consents";
export default class ConsentsStorageManager {
    store(consents) {
        const consentsDataString = JSON.stringify(consents);
        localStorage.setItem(CONSENTS_KEY, consentsDataString);
    }
    restore() {
        const consentsDataString = localStorage.getItem(CONSENTS_KEY);
        if (consentsDataString === null) {
            return null;
        }
        return JSON.parse(consentsDataString);
    }
    erase() {
        localStorage.removeItem(CONSENTS_KEY);
    }
}
